import { Box } from 'styled-system/jsx';
import { RecipeVariantProps } from 'styled-system/types';
import { FC } from 'react';
import { customLabelRecipe } from '@/common/components/base/customLabel/customLabel.recipe.ts';

type PropsType = {
  title: string | number;
} & RecipeVariantProps<typeof customLabelRecipe>;
const CustomLabel: FC<PropsType> = ({ title, ...rest }) => {
  const classes = customLabelRecipe(rest);
  return (
    <Box className={classes.background}>
      <p
        style={{
          whiteSpace: 'nowrap',
        }}
        className={classes.title}
      >
        {title}
      </p>
    </Box>
  );
};

export default CustomLabel;
